module.exports = {
  login: {
    title: '登录',
    subTitle: '还没有账号？',
    goSignUp: '注册',
    Email: '邮箱地址',
    password: '密码',
    goForget: '忘记了你的密码？',
    signUpRule: '继续，即表示您同意我们的',
    TermsConditions: '条款和条件',
    PrivacyPolicy: '隐私策略',
    ShippingPolicy: '物流政策',
    our: '我们',
    and: '和',
    or: '或',
    SignFacebook: 'Sign in with Facebook',
    bindingEmail: `如果你用你的手机注册了你的facebook账户，你就会
    另外需要手动填写一个电子邮件地址，以便您
    可以查看您的订单进度、发货进度等。`,
    Cancel: '取消',
    Confirm: '确认',
    giveawayTitle: '赠品会员',
    giveawaySubTitle: '还不是赠品会员？'
  },
  register: {
    title: '注册',
    subTitle: '已经有账户了吗？',
    goSignIn: '登录',
    firstName: '名',
    lastName: '姓',
    Email: '邮箱地址',
    password: '密码',
    inviteCode: '邀请码（可选）',
    enterpriseSuccess: '恭喜！ 您已通过审核并成为 Gizmogo 合作伙伴！',
    oAffiliate: '普通会员',
    eAffiliate: '合作伙伴',
    eName: '企业名称',
    eType: '企业类型',
    eType1: '电话维修店',
    eType2: '手机店',
    eType3: '回收商店',
    eType4: '餐厅',
    eType5: '环境协会',
    eType6: '其他',
    TCOFEA: 'Gizmogo 合作伙伴的条款和条件',
    errorEin: '请输入正确的EIN',
    goEnterpriseText1: '为您的企业销售产品？',
    goEnterpriseText2: '创建一个免费的企业账户',
    giveawaySubTitle: '已经是赠品会员？'
  },
  forget: {
    title: '重置密码',
    subTitle: '输入与您的gizmogo帐户相关联的邮箱地址。',
    subTitle2: '继续登录?',
    clickHere: '单击此处。',
    Email: '邮箱地址',
    Send: '获取验证码',
    annotation: '验证码有效期为30分钟。',
    code: '验证码',
    ConfirmPassword: '确认新密码',
    password: '密码',
    Submit: '提交',
    sendCodeTitle: '检查您的电子邮件',
    sendCodeText: '如果您找不到我们的邮件，<br/>它可能在您的垃圾邮件/垃圾邮件中',
    personInvitationCodeTitle1: '邀请码的作用是什么？',
    personInvitationCodeTitle2: '如何获得邀请码？',
    personInvitationCodeText1: `当你是一个普通用户时，你可以用你的邀请码来邀请朋友和下订单，完成交易后，你可以获得10美元的推荐奖励。`,
    personInvitationCodeText2: `如果您有一个朋友已经在Gizmogo平台上注册，那么您可以从您的朋友那里获得邀请码。<br />如果您的朋友都没有邀请码，那么您可以选择不填写邀请码。`,
    enterpriseInvitationCodeTitle: '如何获得邀请码？',
    enterpriseInvitationCodeText: `如果你被Gizmogo的销售人员推荐注册，那么你可以从销售人员那里获得邀请码。<br />如果您没有销售人员的邀请码，那么您可以选择不填写邀请码。`,
    giveawaySubTitle: '继续登录？'
  },
  validate: {
    email: '请输入正确的电子邮件地址',
    password: '密码格式应至少包含 8-20 位数字和大小写字母',
    FBEmail: '请输入正确的电子邮件地址!',
    firstName: '请输入姓',
    lastName: '请输入名',
    code: '请输入验证码',
    differPassword: '两个密码不同',
    phone: '请输入正确的联系方式',
    samePassword: "新旧密码不能一致",
    againPassword: "请再次输入新密码",
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/auth.js